import React, { useState, useEffect, useRef } from 'react';
import { getClusterByName } from '@domain/dashboard/cluster/cluster.utils';
import { CLUSTER_SELECTOR_CAMPAIGNS_TEXTS } from '@domain/budget-manager/modal/table/components/cluster-selector/cluster-selector.constants';
import { useBudgetManagerClusters } from '@domain/budget-manager/budget-manager-clusters.hook';
import { useLoggedUser } from '@domain/logged-user';
import { ESC_KEYCODE } from './edit-name-field.constants';
import { ClusterSwitchLoading } from '../../campaign-table-cluster-styles';
import { isFieldLoading } from '../../campaign-table-cluster.utils';
import { ClusterNameFieldWrapper } from './cluster-name-field.wrapper';

interface Props {
    row: any
}

export const ClusterNameFieldContainer = ({
    row,
}: Props) => {
    const {
        clusters,
        updatedCluster,
        updatedClusterState,
        updatedClusterError,
        updateCluster,
    } = useBudgetManagerClusters();
    const { loggedUser } = useLoggedUser();
    const { values: { cluster_name: name = '' } } = row;
    const [editing, setEditing] = useState(false);
    const [value, handleChangeValue] = useState(name);

    useEffect(() => {
        handleChangeValue(name);
    }, [name, updatedClusterError]);

    const cluster = getClusterByName(clusters, name)
    || { name: CLUSTER_SELECTOR_CAMPAIGNS_TEXTS.CAMPAIGN_NOT_CLUSTERED, id: '' };

    const inputRef = useRef(null);

    const handleChangeName = (newName: string) => updateCluster({
        clusterId: cluster.id,
        organizationId: cluster.organizationId,
        userId: loggedUser.id,
        cluster: {
            id: cluster.id,
            name: newName,
            isRecurrent: cluster.isRecurrent,
            clusterObjects: cluster.clusterObjects,
            organizationId: cluster.organizationId,
            ranges: cluster.ranges,
            isBudgetActive: cluster.isBudgetActive,
            isTargetActive: cluster.isTargetActive,
        },
    });

    const enableFieldEdition = () => {
        setEditing(true);
        const input = inputRef.current;
        setImmediate(() => input.focus());
    };

    const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const input = inputRef.current;

        setImmediate(() => input.blur());
        handleChangeName(value);
        setEditing(false);
    };

    const handleValueInputted = () => {
        handleChangeValue(name);
        setEditing(false);
    };

    const handleKeyUp = (ev) => {
        if (ev.keyCode !== ESC_KEYCODE) return;
        handleValueInputted();
    };

    if (isFieldLoading({
        cluster, updatedCluster, updatedClusterState,
    })) {
        return <ClusterSwitchLoading />;
    }

    return (
        <ClusterNameFieldWrapper
            editing={editing}
            enableFieldEdition={enableFieldEdition}
            handleFormSubmit={handleFormSubmit}
            handleChangeValue={handleChangeValue}
            handleValueInputted={handleValueInputted}
            handleKeyUp={handleKeyUp}
            fieldValue={value}
            inputRef={inputRef}
        />
    );
};
